export default __webpack_public_path__ + "static/media/Mozambique.956337b4.png";